<template>
  <div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
               @close='dialogClose' width='1000px'>
      <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
               ref='ruleForm' class='mt20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='委托商：' prop='customerId'>
              <el-select v-model='form.customerId' size='mini' filterable style='width:100%'
                         placeholder='请选择委托商' value-key='id' @change="getCustomerId">
                <el-option v-for='item in customerOptions' :key='item.id'
                           :label='item.customer_name' :value='item'/>
              </el-select>
            </el-form-item>
          </el-col>
            <el-col :span='12'>
              <el-form-item label='合同：' prop='contract'>
                  <el-select v-model="form.contract" filterable style="width: 100%" size="mini"
                           placeholder="请选择合同" value-key="id"  @change="getContractId">
                  <el-option
                    v-for="item in contractOption" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          <el-col :span='12'>
            <el-form-item label='结算类型：' prop='settlementType'>
              <el-select v-model='form.settlementType' size='mini' filterable style='width:100%'
                         placeholder='请选择结算类型' value-key='id' @change='clearData'>
                <el-option v-for='item in settlementTypeOptions' :key='item.value'
                           :label='item.label' :value='item.value' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='港口/库房名称：' prop='nameId'>
              <el-select v-model='form.nameId' size='mini' filterable style='width:100%'
                         placeholder='请选择港口/库房名称' value-key='id' @change="getNameId">
                <el-option v-for='item in nameOptions[form.settlementType]' :key='item.id'
                           :label='item.name' :value='item' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌：' prop='brandIdList'>
              <el-select v-model='form.brandIdList' size='mini' filterable style='width:100%'
                         multiple @change='changeSelect'
                         collapse-tags placeholder='请选择品牌' value-key='id'>
                <el-checkbox class='my-checkbox' v-model='checked' @change='selectAll'>全选
                </el-checkbox>
                <el-option v-for='item in brandOptions' :key='item.id'
                           :label='item.brand' :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='作业类型：' prop='taskTypeId'>
              <el-select v-model='form.taskTypeId' size='mini' filterable style='width:100%'
                         placeholder='请选择作业类型' value-key='id'>
                <el-option
                  v-for='item in taskTypeOptions[form.settlementType === 0 ? "warehouseWork" : form.settlementType === 1 ? "portWork" : ""]'
                  :key='item.id' :label='item.workType' :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='有效期始：' prop='date'>
              <el-date-picker
                v-model="form.date"
                type="datetimerange"
                align="right"
                size="mini"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style='width:100%'
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='税率：' prop='taxRate'>
              <el-input v-model='form.taxRate' size='mini' type='number' placeholder='请输入税率'>
                <template slot='append'>%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='预估价：'>
              <el-input v-model='form.estimatePrice' size='mini' type='number' placeholder='请输入预估价'>
                <template slot='append'>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='结算价设置：'>
              <el-row>
                <el-col :span='12'>
                  {{
                    this.dialogForm.type === 1 ? '合同价' : (this.dialogForm.type === 2 ? '预结算价' : '未设置')
                  }}
                </el-col>
                <el-col :span='12'>
                  {{
                    this.dialogForm.type && this.dialogForm.type !== 0 ? '价格：' + this.dialogForm.price : ''
                  }}
                  <span class='set-up' @click='priceSetBtn'>设置</span>
                </el-col>
              </el-row>
<!--              <el-row-->
<!--                v-if='this.dialogForm.selectContract.companyName || this.dialogForm.selectContract.codeNumber'>-->
<!--                <el-col :span='12'>-->
<!--                  <span class='item-span'>-->
<!--                    合同名称：{{ this.dialogForm.selectContract.companyName }}-->
<!--                  </span>-->
<!--                </el-col>-->
<!--                <el-col :span='12'>-->
<!--                  <span class='item-span'>-->
<!--                    合同编号：{{ this.dialogForm.selectContract.codeNumber }}-->
<!--                  </span>-->
<!--                </el-col>-->
<!--              </el-row>-->
            </el-form-item>
          </el-col>
        </el-row>
        <div class='flex-center-center mt20'>
          <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 结算价格设置 -->
    <settlement-price-setting ref='settlementPriceSettingRef' @selectedChange='selectedChange' />
  </div>
</template>

<script>
import {contractPageList, customerInfoSelectList} from '@/service/financial';
  import SettlementPriceSetting
    from '@/views/financial/price/harbor-warehouse-income-price-setting/components/settlement-price-setting';
  import {
    getName, getTaskType,
    portWarehouseConsignorPriceSettingAdd,
    portWarehouseConsignorPriceSettingUpdate,
  } from '@/service/warehouse';
  import { getModelList } from '@/service/vehiclelog';
  import divBorder from "@/components/divBorder.vue";

  export default {
    name: 'harborWarehouseIncomePriceSettingForm',
    components: {divBorder, SettlementPriceSetting },
    data() {
      return {
        checked: false,
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        form: {
          settlementType: '',
          nameId: {
            id: '',
            name: ''
          },
          contract:'',
          brandIdList: '',
          taskTypeId: '',
          date: '',
          taxRate: '',
          estimatePrice: '',
          customerId:{
            id: '',
            customer_name: ''
          }
        },
        contractOption: [],
        rules: {
          customerId: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'blur',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'blur',
            },
          ],
          settlementType: [
            {
              required: true,
              message: '请选择结算类型',
              trigger: 'blur',
            },
          ],
          brandIdList: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'blur',
            },
          ],
          nameId: [
            {
              required: true,
              message: '请选择港口/库房名称',
              trigger: 'blur',
            },
          ],
          taskTypeId: [
            {
              required: true,
              message: '请选择作业类型',
              trigger: 'blur',
            },
          ],
          date: [
            {
              required: true,
              message: '请选择有效期始',
              trigger: 'blur',
            },
          ],
          taxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        settlementTypeOptions: [
          {
            label: '库房',
            value: 0,
          },
          {
            label: '港口',
            value: 1,
          },
        ],
        customerOptions: [],
        brandOptions: [],
        nameOptions: [],
        taskTypeOptions: [],
        defaultDialogForm: {},
        dialogForm: {
          selectContract: {
            companyName: '',
            codeNumber: '',
          },
        },
      };
    },
    mounted() {
      this.getSelectedData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      this.defaultDialogForm = JSON.parse(JSON.stringify(this.dialogForm));
    },
    methods: {
      selectAll() {
        this.form.brandIdList = [];
        if (this.checked) {
          this.brandOptions.map((item) => {
            this.form.brandIdList.push(item.id);
          });
        } else {
          this.form.brandIdList = [];
        }
      },
      changeSelect(val) {
        this.checked = val.length === this.brandOptions.length;
      },
      selectedChange(dialogForm) {
        this.dialogForm = dialogForm;
        // this.form.contractId = dialogForm.selectContract.id;
        switch (dialogForm.type) {
          case 1:
            this.form.contractPrice = dialogForm.price;
            break;
          case 2:
            this.form.preparePrice = dialogForm.price;
            break;
        }
      },
      getSelectedData() {
        this.getCustomerInfoSelectList();
        this.getBrand();
        this.getName();
        this.getTaskType();
      },
      clearData() {
        if (this.form.nameId) this.form.nameId = '';
      },
      async getTableData() {
        let res = await contractPageList({companyName: this.form.customerId.customer_name});
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      // 获取委托商
      async getCustomerInfoSelectList() {
        const {
          status,
          message,
          data,
        } = await customerInfoSelectList();
        if (status !== 0) return this.$message.warning(message);
        this.customerOptions = data;
      },
      // 获取品牌
      async getBrand() {
        const {
          status,
          message,
          data,
        } = await getModelList();
        if (status !== 0) return this.$message.warning(message);
        this.brandOptions = data;
      },
      // 获取库房/港口
      async getName() {
        const {
          status,
          message,
          data,
        } = await getName();
        if (status !== 0) return this.$message.warning(message);
        this.nameOptions = data;
      },
      // 获取任务类型
      async getTaskType() {
        const {
          status,
          message,
          data,
        } = await getTaskType();
        if (status !== 0) return this.$message.warning(message);
        this.taskTypeOptions = data;
      },
      // 结算价格设置
      priceSetBtn() {
        if (!this.form.customerId.customer_name) return this.$message.warning('请选择委托商后设置结算价格！');
        this.dialogTitle === '新增' ?
          this.$refs.settlementPriceSettingRef.dialogOpen(this.form.customerId.customer_name) :
          this.$refs.settlementPriceSettingRef.dialogOpen(this.form.customerId.customer_name, this.dialogForm);
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        if (row) this.rowFormat(row);
        this.dialogVisible = true;
      },
      getCustomerId(val){
        this.form.contract = ''
        this.getTableData(val)
      },
      getNameId(val){
        console.log(val,"111")
      },
      getContractId(val){
        this.$forceUpdate()
        console.log(val,"3333")
      },
      async rowFormat(row) {
        this.form = row
        this.form.contract = row.contractId
        this.form.customerId = {
          id: row.customerId,
          customer_name: row.customerName
        }
        this.form.nameId = {
          id: row.nameId,
          name: row.name
        }
        this.form.date = [row.startDate, row.endDate];
        this.dialogForm = {
          type: row.estimatePrice ? 0 : row.contractPrice ? 1 : 2,
          price: row.contractPrice || row.preparePrice || row.estimatePrice,
          // selectContract: {
          //   companyName: row.companyName,
          //   codeNumber: row.codeNumber,
          // },
        };
        let res = await contractPageList({companyName: row.customerName});
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.dialogForm = JSON.parse(JSON.stringify(this.defaultDialogForm));
      },
      submit() {
        if (!(this.form.estimatePrice || this.form.contractPrice || this.form.preparePrice)) return this.$message.warning('请在预估价、合同价和预结算价中选择一个填写！');
        if (this.form.estimatePrice && (this.form.contractPrice || this.form.preparePrice)) return this.$message.warning('预估价与合同价（预结算价）不能同时选择！');
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let data;
            if (this.form.id) {
              this.submitLoading = true
              // console.log(this.rowFormat);
              // console.log(this.form);
              data = await portWarehouseConsignorPriceSettingUpdate({
                id: this.form.id,
                settlementType: this.form.settlementType,
                nameId: this.form.nameId.id,
                brandIdList: this.form.brandIdList,
                taskTypeId: this.form.taskTypeId,
                date: this.form.date,
                taxRate: this.form.taxRate,
                estimatePrice: this.form.estimatePrice,
                customerId: this.form.customerId.id,
                customerName: this.form.customerId.customer_name,
                contractPrice:  this.form.contractPrice,
                preparePrice: this.form.preparePrice,
                contractId: this.form.contract,
                brandIds: this.form.brandIdList.join(','),
                startDate: this.form.date[0],
                endDate: this.form.date[1],
              });
              this.submitLoading = false
            } else {
              this.submitLoading = true
              data = await portWarehouseConsignorPriceSettingAdd({
                settlementType: this.form.settlementType,
                nameId: this.form.nameId.id,
                name: this.form.nameId.name,
                brandIdList: this.form.brandIdList,
                taskTypeId: this.form.taskTypeId,
                date: this.form.date,
                taxRate: this.form.taxRate,
                estimatePrice: this.form.estimatePrice,
                customerId: this.form.customerId.id,
                customerName: this.form.customerId.customer_name,
                contractPrice:  this.form.contractPrice,
                preparePrice: this.form.preparePrice,
                contractId: this.form.contract,
                brandIds: this.form.brandIdList.join(','),
                startDate: this.form.date[0],
                endDate: this.form.date[1],
              });
              this.submitLoading = false
            }
            if (data.status !== 0) return this.$message.warning(data.message);
            this.$message.success(data.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .set-up {
    color: #3187ff;
    position: absolute;
    // width: 26px !important;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: -8px;
    top: calc(50% - 12px);
    text-decoration: none;
    cursor: pointer;
  }
</style>
